import styled from "styled-components"

export const SlideImageWrapper = styled.div`
  margin-bottom: 30px;

  div {
    height: inherit;
  }
  .slide_item{
    display: flex !important;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
  }
  .image-item {
    border-radius: 12px;
    /* width: 100%; */
    margin: 0 16px;
    width: 610px;
    height: 320px;
    box-shadow: 0px 4px 8px rgba(34, 24, 24, 0.4);
  }
  .slick-slide div {
    outline: none !important;
  }

  .image-slider{
  }

  .slick-dots li button {
    &:before {
      font-size: 12px;
    }
  }

  .slick-dots li.slick-active button {
    &:before {
      color: #f7ec96;
    }
  }

  .slick-dots {
    bottom: 5px;
  }
`
